import { defineStore } from 'pinia'
import axios from 'axios'
import {ref} from 'vue'
import { useRoute,useRouter } from 'vue-router'

export const useApiSettingStore = defineStore('ApiSettingStore', {
    state: () => {
        return {
            CLIXLO:1,
            CONNECTALLY:2,
            GOHIGHLEVEL:3,
            NINJA_AUTOMATION: 4,
            OTHERS: 5,
            api_list:[
                {
                    id: 1,
                    name:'Clixlo',
                },
                {
                    id: 2,
                    name: 'Connectally'
                },
                {
                    id: 3,
                    name: 'GoHighLevel'
                },
                {
                    id: 4,
                    name: 'Ninja Automation'
                },
                {
                    id: 5,
                    name: 'Other'
                }
            ],
            ACTIVE:1,
            apiKeys: ref(),
            route: useRoute(),
            router: useRouter(),
        }
    },
    actions: {
        async fetchApiSetting() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'show-api-key-settings'
                    }
                );
                this.apiKeys = await axios.get(route.href)
                .then(function (response) {
                    if (response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    return response.data.data;
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
    getters: {
        getApiSetting: (state) => {
            return () => {
                return state.apiKeys;
            }
        },
    },
})
